export default __webpack_public_path__ + "static/media/img2.46c65617.png";